<template>
  <div class="button_wrapper">
    <b-button v-if="type == 'add' && role === 'merchant'"
              class="add"
              v-b-modal.modal-multi-add
              variant="primary"
              @click="success = false">
              <div class="icon icon-sub-merchant"></div>
              新增附屬帳戶
    </b-button>
    <b-button v-else-if="type == 'add' && (role === 'admin' || role === 'sale')"
              class="add"
              v-b-modal.modal-multi-add
              variant="link"
              @click="success = false">
              <div class="icon icon-sub-merchant"></div>
              ＋ 新增附屬帳戶
    </b-button>
    <b-button v-else-if="type == 'edit'"
              v-b-modal="'modal-multi-edit-' + id"
              variant="light"
              @click="success = false">
      <b-icon-pencil-fill variant="secondary" font-scale="1.3"></b-icon-pencil-fill>
    </b-button>
    <b-button v-else
              v-b-modal.modal-multi-list
              variant="outline-secondary">
              <div class="icon icon-sub-merchant"></div>
              管理附屬帳戶
    </b-button>
  </div>
</template>

<script>
import {
  BButton,
  BIconPencilFill,
} from 'bootstrap-vue';

export default {
  name: 'ButtonSubMerchant',
  props: ['type', 'merchantId', 'id', 'role'],
  data: () => ({
    success: false,
  }),
  components: {
    BIconPencilFill,
    BButton,
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.button_wrapper {
  margin-right: 6px;
  text-align: center;
  .add{
    float:right;
    margin-bottom:5px;
  }
  .icon-sub-merchant {
    width: 21px;
    background-image: url(../../assets/img/icon/merchant.svg);
  }
}
</style>
